import superagent from 'superagent'

export const polygonsSet = polygons => ({
  type: 'POLYGONS_SET',
  payload: polygons
})

export const polygonCreate = polygon => ({
  type: 'POLYGON_CREATE',
  payload: polygon
})

export const polygonUpdate = polygon => ({
  type: 'POLYGON_UPDATE',
  payload: polygon
})

export const polygonDelete = id => ({
  type: 'POLYGON_DELETE',
  payload: id
})

export const polygonFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/measurement/get?activityId=1&measurementType=3`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        res.body.map(s => {
          if (s.photoId) {
            $.ajax({
              method: 'GET',
              url: `${__API_URI__}/photo/get/${s.photoId}`,
              headers: {
                Authorization: `Bearer ${token}`,
                Platform: 'Web',
                Version: `${__version__}`
              }
            }).done(res => {
              s.photo = res
            })
          }
        })
        resolve(res.body)
        dispatch(polygonsSet(res.body))
      })
  })
}

export const polygonCreateRequest = polygonObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(polygonObj))
      .end((err, res) => {
        if (err) {
          return reject(err)
        }
        Countly.q.push([
          'add_event',
          {
            key: 'Create Polygon',
            count: 1
          }
        ])
        if (res.body.photoId) {
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.body.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`,
            },
          })
            .done((photoRes) => {
              // Add the photo data to the main response body
              res.body.photo = photoRes;
              // Dispatch the circle creation with the updated payload
              dispatch(polygonCreate(res.body));
              resolve(res.body);
            })
            .fail((ajaxErr) => {
              console.error('Error fetching photo details:', ajaxErr);
              reject(ajaxErr);
            });
        } else {
          // Directly dispatch if no photoId is present
          dispatch(polygonCreate(res.body));
          resolve(res.body);
        }
      })
  })
}

export const polygonUpdateRequest = polygonObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(polygonObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        } else {
          if (res.photoId) {
            $.ajax({
              method: 'GET',
              url: `${__API_URI__}/photo/get/${res.photoId}`,
              headers: {
                Authorization: `Bearer ${token}`,
                Platform: 'Web',
                Version: `${__version__}`
              }
            }).done(res => {
              res.photo = res
            })
          }
          dispatch(polygonUpdate(res.body))
        }
        resolve(res.body)
      })
  })
}

// Rejects with the superagent error when the delete fails (WEB-7103), and only then leaves the
// object in the store; it's removed once the server confirms.
export const polygonDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) return reject(err)
        dispatch(polygonDelete(id))
        resolve(res.body)
      })
  })
}
